import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ChevronRight, ArrowLeft } from "lucide-react";

export default function PageHeaderBreadcrumbs({ overrides = {} }) {
  const navigate = useNavigate();
  const location = useLocation();

  const pathSegments = location.pathname.split("/").filter(Boolean);

  const breadcrumbs = pathSegments.map((segment, index) => {
    const href = "/" + pathSegments.slice(0, index + 1).join("/");

    const autoLabel = segment
      .replace(/-/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());

    const label = overrides[segment] || autoLabel;

    return { label, href };
  });

  return (
    <div className="flex items-center gap-3 mb-6">

      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="w-8 h-8 rounded-full border border-border flex items-center justify-center hover:bg-secondary transition shrink-0"
      >
        <ArrowLeft className="w-4 h-4 text-foreground" />
      </button>

      <nav className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground" aria-label="Breadcrumb">
        {breadcrumbs.map((item, idx) => {
          const isLast = idx === breadcrumbs.length - 1;
          return (
            <span key={idx} className="flex items-center gap-2">
              {!isLast ? (
                <Link
                  to={item.href}
                  className="text-muted-foreground hover:text-primary"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground font-medium">{item.label}</span>
              )}
              {!isLast && (
                <ChevronRight className="w-4 h-4 text-muted-foreground" />
              )}
            </span>
          );
        })}
      </nav>

    </div>
  );
}
